import React, { FC, ChangeEvent } from 'react'
import classNames from 'classnames'
import { ISelectOption } from 'components/forms/Selects'
import { TAG_SIZE, TAG_STYLE, ITagProps } from '../Tag'

export interface ITagSelectProps extends Omit<ITagProps, 'label'> {
  options: ISelectOption<string>[]
  value: ISelectOption<string> | undefined
  disabled?: boolean
  onChange: (val: ChangeEvent<HTMLSelectElement>) => void
}

export const TagSelect: FC<ITagSelectProps> = ({
  size = TAG_SIZE.medium,
  tagStyle = TAG_STYLE.dark,
  className = '',
  dataTest = '',
  dataTooltip,
  outlineOnly,
  style,
  options = [],
  onChange,
  value: valueProp,
  disabled = false,
}) => (
  <select
    disabled={disabled}
    className={classNames(
      `dpl-tag-select dpl-tag dpl-tag-select-${size} dpl-tag-${tagStyle}`,
      className,
      {
        'dpl-tag-outline': outlineOnly,
      }
    )}
    style={style}
    data-tooltip={dataTooltip}
    onChange={onChange}
    value={valueProp?.value}
    data-test={dataTest}>
    {options.map(({ label, value }) => (
      <option key={value} value={value} data-test='tag-select-option'>
        {label}
      </option>
    ))}
  </select>
)

export default TagSelect
